export default {
  getAccess(state) {
    return state.access;
  }
};
